import * as types from './mutation-types';

export default {
    [types.FETCH_NOTICE_LIST](state, payload) {
        state.noticeItems = Array.isArray(payload) ? payload : [];
    },

    [types.SET_CURRENT_NOTICE](state, payload) {
        state.currentNotice = payload || null;
    },
};
